import { STEP_SECONDS, WIDTH, rowY } from './constants';
import type { Enemy, Platform } from './state';
import type { LevelConfig } from './levels';
export function createEnemies(config: LevelConfig, platforms: Platform[]): Enemy[] {
  const result: Enemy[] = [];
  if (config.snakes) result.push({id:'median-snake',kind:'snake',x:190,previousX:190,y:rowY(6),w:24,direction:-1,active:false});
  if (config.snakes>1) result.push({id:'log-snake',kind:'snake',x:0,previousX:0,y:rowY(9),w:24,direction:1,active:false,carrierId:platforms.find(p=>p.lane===3)?.id});
  if (config.otter) result.push({id:'otter',kind:'otter',x:-40,previousX:-40,y:rowY(10),w:25,direction:1,active:false});
  return result;
}
export function updateEnemies(enemies: Enemy[], platforms: Platform[], frame: number): void {
  for (const e of enemies) {
    e.previousX=e.x;
    if (e.kind==='otter') {
      const phase=frame%1100;e.active=phase>700;
      e.y=rowY(7+(Math.floor(frame/1100)%5));
      e.x=(phase-700)*0.8-40; continue;
    }
    e.active=frame>210;
    if (e.carrierId) {
      const p=platforms.find(p=>p.id===e.carrierId);if (p) e.x=p.x+p.w/2-12+Math.sin(frame/80)*28;
    } else {
      e.x+=e.direction*22*STEP_SECONDS;
      if (e.x<0) {e.x=0;e.direction=1;}
      if (e.x>WIDTH-e.w) {e.x=WIDTH-e.w;e.direction=-1;}
    }
  }
}
